import { CwtApiSchema, CwtProp, CwtSchema } from "@cawita/core-front/api";

@CwtSchema()
export class CustomerStat extends CwtApiSchema {
    @CwtProp() count: number;
}